<script lang="ts" setup>
import {Ref, ref} from 'vue';
import {APP_EMBEDDED} from '../app.const';
import logo from './assets/logo.svg';
import LoginForm from './components/LoginForm.vue';

const props = defineProps<{
    account?: string;
    onSuccess?: () => void;
}>();

const emit = defineEmits(['success']);
const ready: Ref<boolean> = ref(false);

function onLoginSuccess() {
    console.log('ON_LOGIN_SUCCESS');
    if (props.onSuccess) {
        props.onSuccess();
        onReady(false);
    }
}

function onReady(showLogin: boolean = true) {
    ready.value = showLogin;
}

const account = getAccountName();

function getAccountName(): string {
    if (props.account) {
        return props.account;
    }
    if (APP_EMBEDDED()) {
        const evoUrlRegex = /(.+).erp.accessacloud.com/;
        const evoUrl = document.location.host.match(evoUrlRegex);
        if (evoUrl) {
            return evoUrl[1];
        }
        const params = new URLSearchParams(document.location.search);
        return params.get('account');
    }
    return document.location.pathname.replace(/\//g, '');
}
</script>
<template>
    <div class="h-full w-full bg-mx auth" :class="{visible: ready}">
        <div class="w-560 h-full bg-white relative">
            <div class="absolute top-3 left-3"><img :src="logo" /></div>
            <div class="absolute top-1/2 left-1/2 w-80 -translate-x-1/2 -translate-y-1/2">
                <LoginForm :account="account" @success="onLoginSuccess" @ready="onReady" />
            </div>
        </div>
        <div class="logo-panel">
            <div class="line-1"></div>
            <div class="line-2"></div>
        </div>
    </div>
</template>
<style lang="less" scoped>
.auth {
    &.visible {
        visibility: visible;
    }
    visibility: hidden;
}
.w-560 {
    width: 560px;
}
.bg-mx {
    background-color: #1b1c41;
}
.logo-panel {
    background-color: #1b1c41;
    position: absolute;
    top: 0;
    left: 560px;
    right: 0;
    bottom: 0;
    .line-1 {
        border: 1px solid #3ce35c;
        height: 50%;
        width: 560px;
        border-top: none;
        border-left: none;
    }

    .line-2 {
        border: 1px solid #3ce35c;
        height: 150%;
        border-top-left-radius: 420px;
        border-right: none;
        border-bottom: none;
        width: 150%;
        margin-top: -1px;
    }
}
</style>
